import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import RefreshIcon from "@material-ui/icons/Refresh";
import CameraAltOutlinedIcon from "@material-ui/icons/CameraAltOutlined";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import VideocamIcon from "@material-ui/icons/Videocam";
import VideocamOutlinedIcon from "@material-ui/icons/VideocamOutlined";

import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";

//actions
import * as shootActions from "../../redux/actions/shootsactions";
import * as dialogActions from "../../redux/actions/dialogactions";

//Services
import shotService from "../../services/shotService";

class PackageTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      failed: false,
      data: [],
      open: false,
      openMenu: false,
      selectedMenu: null,
      selectedQuestion: {},
      selectedPackage: {},
      orderBy: "title",
      order: "asc",
      filterstate: "",
      openConfirmation: false,
      openTypeConfirmation: false,
      packagedata: {
        title: "",
        description: "",
        type: ""
      }
    };
  }

  async componentDidMount() {
    this.getPackages();
  }

  async componentDidUpdate(prevProps) {}

  getPackages = async () => {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let { data } = await shotService.getPackages();
      console.log("data", data);
      this.setState({ data, fetching: false, failed: false });
    } catch (err) {
      console.log(err);
      this.setState({ data: [], fetching: false, failed: true });
    }
  };

  addPackage = () => {
    this.setState({ open: true });
  };
  handleMenu = (e, selectedPackage) => {
    console.log(selectedPackage);
    this.setState({ selectedMenu: e.currentTarget, openMenu: true, selectedPackage });
  };
  // handleMenu = (e, selectedQuestion) => {
  //   this.setState({ selectedMenu: e.currentTarget, open: true, selectedQuestion });
  // };

  handleClose = () => {
    this.setState({ open: false, openMenu: false, selectedPackage: {}, packagedata: {} });
  };
  handleCloseMenu = () => {
    this.setState({ openMenu: false, selectedPackage: {}, packagedata: {} });
  };
  onEdit = async (e, selectedQuestion) => {
    // let { clinic, created_at } = this.state.selectedPackage;
    // console.log('shoot', this.state.selectedPackage);

    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let { data } = await shotService.getOnePackage(this.state.selectedPackage.id);
      console.log("dataedit", data);
      this.setState({ packagedata: data, fetching: false, failed: false });
    } catch (err) {
      console.log(err);
      this.setState({ packagedata: {}, fetching: false, failed: true });
    }

    this.setState({
      open: true
    });
    // this.props.history.push(`/question/edit/${selectedQuestion.id}/${selectedQuestion.type}`);
  };
  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  stableSort = (array, cmp) => {
    console.log("data", array);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  desc = (a, b, orderBy) => {
    if (b[orderBy].toUpperCase() < a[orderBy].toUpperCase()) {
      return -1;
    }
    if (b[orderBy].toUpperCase() > a[orderBy].toUpperCase()) {
      return 1;
    }
    return 0;
  };
  handleChangeFilter = e => {
    console.log("filter", e.target.value);
    this.setState({
      filterstate: e.target.value
    });
  };
  handleChange = e => {
    const { packagedata } = this.state;
    let id = e.target.name;
    packagedata[id] = e.target.value;
    console.log("type", packagedata, e.target);

    this.setState({
      openTypeConfirmation: false
    });
  };

  handleAddPackage = async () => {
    try {
      this.setState({
        fetching: true,
        confirmed: false
      });
      let { title, description, type } = this.state.packagedata;
      let account = await shotService.addPackage({
        title,
        description,
        type
      });
      console.log(account);
      this.setState({
        fetching: false
      });
      this.handleClose();
      this.getPackages();
    } catch (err) {
      this.setState({ fetching: false });
      //  this.props.setFieldError("email", "Email is already taken");
    }
  };

  handleEditPackage = async () => {
    try {
      this.setState({
        fetching: true,
        confirmed: false
      });
      let { title, description, type } = this.state.packagedata;
      let account = await shotService.editOnePackage(this.state.selectedPackage.id, {
        title,
        description,
        type
      });
      console.log(account);
      this.setState({
        fetching: false
      });
      this.handleClose();
      this.getPackages();
    } catch (err) {
      this.setState({ fetching: false });
      //  this.props.setFieldError("email", "Email is already taken");
    }
  };

  onAddPhotoShot = () => {
    console.log(this.state.selectedPackage);
    this.props.history.push(`/packages/add/${this.state.selectedPackage.id}/photo-shots?type=photo`);
  };
  onAddVideoShot = () => {
    console.log(this.state.selectedPackage);
    this.props.history.push(`/packages/add/${this.state.selectedPackage.id}/photo-shots?type=video`);
  };

  addShotToPackages = () => this.props.history.push(`/packages/${this.state.selectedPackage.id}/shots/add`);

  viewShoot = shoot => {
    this.props.history.push(`/packages/view/${this.state.selectedPackage.id}`);
  };

  handleCloseConfirmation = () => {
    this.setState({
      openConfirmation: false
    });
  };
  handleOpenConfirmation = () => {
    this.setState({
      openConfirmation: true
    });
  };
  handleCloseTypeConfirmation = () => {
    this.setState({
      openTypeConfirmation: false
    });
  };
  handleOpenTypeConfirmation = () => {
    this.setState({
      openTypeConfirmation: true
    });
  };
  onDelete = async () => {
    try {
      this.setState({
        fetching: true,
        confirmed: false
      });
      let { id } = this.state.selectedPackage;
      let account = await shotService.deleteOnePackage(id);
      console.log(account);
      this.setState({
        fetching: false
      });
      this.handleClose();
      this.handleCloseConfirmation();
      this.getPackages();
    } catch (err) {
      this.setState({ fetching: false });
      //  this.props.setFieldError("email", "Email is already taken");
    }
  };
  render() {
    const open = this.state.open;
    const { orderBy, order, data, filterstate, packagedata, selectedPackage, editData } = this.state;
    console.log("edited", this.state.packagedata);
    let queryData = this.stableSort(data, this.getSorting(order, orderBy));
    const sessionList = queryData
      .filter(e => e.type.includes(filterstate))
      .map((session, key) => {
        return (
          <TableRow key={key}>
            <TableCell>{session.title}</TableCell>
            <TableCell>{session.description}</TableCell>
            <TableCell>{session.type}</TableCell>
            <TableCell>
              <div>
                <IconButton
                  aria-label="More"
                  aria-owns={open ? "long-menu" : undefined}
                  aria-haspopup="true"
                  onClick={e => this.handleMenu(e, session)}
                >
                  <MoreVertIcon />
                </IconButton>
              </div>
            </TableCell>
          </TableRow>
        );
      });

    const headRows = [
      { id: "title", numeric: false, disablePadding: false, label: "Title" },
      { id: "", numeric: false, disablePadding: false, label: "Description" },
      { id: "type", numeric: false, disablePadding: false, label: "Type" },
      { id: "", numeric: false, disablePadding: false, label: "Action" }
    ];

    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Shot Packages" hasPadding={true}>
          <Toolbar variant="dense" style={{ padding: "10px 5px 20px", margin: "auto", width: 800 }} disableGutters={true}>
            <Typography variant="body2" color="textSecondary">
              Total Records: <b>{this.state.data.length}</b>
            </Typography>
            <div style={{ flexGrow: 1 }} />
            <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
              Filter Type:
            </Typography>
            <FormControl variant="outlined" style={{ marginRight: 10 }}>
              <Select
                value={this.state.filterstate}
                onChange={this.handleChangeFilter}
                displayEmpty={true}
                input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="photo">Photo</MenuItem>
                <MenuItem value="video">Video</MenuItem>
              </Select>
            </FormControl>
            <Divider style={{ margin: "0 10px", height: 40, width: 2 }} />
            <div>
              <Tooltip title="Refresh List">
                <IconButton onClick={this.getPackages} aria-label="Refresh">
                  <RefreshIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Add Question">
                <Fab
                  size="small"
                  color="primary"
                  onClick={this.addPackage}
                  aria-label="Add"
                  style={{
                    marginLeft: "5px",
                    boxShadow: "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)"
                  }}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </div>
          </Toolbar>
          <Paper
            style={{
              width: 800,
              margin: "auto"
            }}
          >
            {this.state.fetching ? <LinearProgress color="primary" style={{ height: 2 }} /> : null}
            {this.state.failed ? (
              <div style={{ padding: "20px 0", textAlign: "center" }}>
                <Typography variant="h3" gutterBottom style={{ color: "rgba(0,0,0,0.5)" }}>
                  Something went wrong...
                </Typography>
                <Button variant="outlined" color="primary" onClick={this.getShoots}>
                  Reload
                </Button>
              </div>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    {headRows.map((row, key) => (
                      <TableCell
                        key={key}
                        align={row.numeric ? "right" : "left"}
                        padding={row.disablePadding ? "none" : "default"}
                        sortDirection={orderBy === row.id ? order : false}
                        onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                        style={row.id == "" ? null : { cursor: "pointer" }}
                      >
                        {this.state.orderBy === row.id ? (
                          <TableSortLabel active={orderBy === row.id} direction={order}>
                            {row.label}
                          </TableSortLabel>
                        ) : (
                          row.label
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>{sessionList}</TableBody>
              </Table>
            )}
          </Paper>
          <Dialog
            maxWidth="xs"
            open={open}
            onClose={this.handleClose}
            disableBackdropClick={this.state.fetching ? true : false}
            disableEscapeKeyDown={this.state.fetching ? true : false}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">{selectedPackage.id ? "Edit Package" : "Add Package"}</DialogTitle>
            <DialogContent>
              <DialogContentText>Please add shot packages and fill up all required fields.</DialogContentText>
              <TextField
                autoComplete="off"
                id="title"
                name="title"
                defaultValue={this.state.packagedata != undefined ? this.state.packagedata.title : ""}
                onChange={this.handleChange}
                label="Package Name"
                margin="normal"
                style={{ width: "100%", fontSize: "80px" }}
                variant="outlined"
              />
              <TextField
                id="description"
                name="description"
                label="Description"
                multiline
                rows="4"
                defaultValue={this.state.packagedata != undefined ? this.state.packagedata.description : ""}
                onChange={this.handleChange}
                margin="normal"
                variant="outlined"
                style={{ width: "100%", fontSize: "80px", marginBottom: 20 }}
              />
              <FormControl>
                <FormLabel component="legend">Type</FormLabel>
                <RadioGroup
                  aria-label="gender"
                  id="type"
                  name="type"
                  onChange={selectedPackage.id ? this.handleOpenTypeConfirmation : this.handleChange}
                  defaultValue={this.state.packagedata != undefined ? this.state.packagedata.type : ""}
                >
                  <FormControlLabel
                    value="photo"
                    control={<Radio color="primary" icon={<CameraAltOutlinedIcon />} checkedIcon={<CameraAltIcon />} />}
                    label="Photo"
                  />
                  <FormControlLabel
                    value="video"
                    control={<Radio color="primary" icon={<VideocamOutlinedIcon />} checkedIcon={<VideocamIcon />} />}
                    label="Video"
                  />
                </RadioGroup>
                <FormHelperText>Changing Package Type will delete all the shots related to it.</FormHelperText>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} disabled={this.state.fetching ? true : false} color="primary">
                Cancel
              </Button>
              <Button
                onClick={selectedPackage.id ? this.handleEditPackage : this.handleAddPackage}
                disabled={this.state.fetching ? true : false}
                color="primary"
              >
                {selectedPackage.id ? "Edit" : "Add"}
                {this.state.fetching ? <CircularProgress size={12} color="inherit" style={{ marginLeft: 5 }} /> : null}
              </Button>
            </DialogActions>
          </Dialog>
          <Menu
            id="long-menu"
            anchorEl={this.state.selectedMenu}
            open={this.state.openMenu}
            onClose={this.handleCloseMenu}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            PaperProps={{
              elevation: 1
            }}
          >
            <MenuItem onClick={() => this.viewShoot(this.state.selectedPackage)} key="view">
              View Package
            </MenuItem>
            {this.state.selectedPackage.id !== "82ccc656-bae6-4e0d-97ca-7b0a63ff4e6f" &&
              this.state.selectedPackage.id !== "678336f4-231c-4181-947a-95655434e06c" && [
                <MenuItem key="add-shots" onClick={this.addShotToPackages}>
                  {selectedPackage.type == "photo" ? `Add Photo Shots` : `Add Video Shots`}
                </MenuItem>,
                <MenuItem key="edit-package" onClick={this.onEdit} key="edit">
                  Edit Package Details
                </MenuItem>,
                <MenuItem key="delete-package" onClick={this.handleOpenConfirmation} key="delete">
                  Delete
                </MenuItem>
              ]}
          </Menu>
          <Dialog
            open={this.state.openConfirmation}
            onClose={this.handleCloseConfirmation}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You are about to delete the whole package with all the shots in it. Would you like to continue?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseConfirmation} color="primary">
                No
              </Button>
              <Button onClick={this.onDelete} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.openTypeConfirmation}
            onClose={this.handleCloseTypeConfirmation}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Are you sure?"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You are about to change the Package Type which will also delete all the shots related to it upon clicking Edit. Would you like to
                continue?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseTypeConfirmation} color="primary">
                No
              </Button>
              <Button onClick={this.handleChange} color="primary" autoFocus>
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageTable);
